import React, { useEffect, useState } from "react";
import { ax_warranty_getAllWarranty } from "../api/warranty";
import { useNavigate } from "react-router";
import TableHeadOptions from "../component/TableHeadOptions";
import Table from "../component/Table";
import Loading from "../component/Loading";
// import { useNavigation } from "react-router";

const WarrList = ({ setSelectedWarranty, createdFromBrand }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [allWarranty, setAllWarranty] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [isSortedLatest, setIsSortedLatest] = useState(false);

  // const today = new Date();
  // const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  // const formattedStartDate = startDate.toISOString().split("T")[0];

  // Get the last date of the current month (end of the month)
  // const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  // const formattedEndDate = endDate.toISOString().split("T")[0];

  const [filterDate, setFilterDate] = useState({
    // startDate: formattedStartDate,
    // endDate: formattedEndDate,
    startDate: "",
    endDate: "",
  });

  const itemsPerPage = 5;
  //   const startIndex = (currentPage - 1) * itemsPerPage;

  //   const displayedWarranty = allWarranty.slice(
  //     startIndex,
  //     startIndex + itemsPerPage
  //   );

  const toggleFilter = () => {
    // setIsFilterExpanded((prev) => !prev);
    setIsLoading(true);
    setIsSortedLatest((prev) => !prev);

    setAllWarranty((prevWarranties) => {
      return [...prevWarranties].sort((a, b) => {
        return isSortedLatest
          ? new Date(a.createdAt) - new Date(b.createdAt) // Oldest to latest
          : new Date(b.createdAt) - new Date(a.createdAt); // Latest to oldest
      });
    });
    setIsLoading(false);
  };

  //   const totalPages = Math.ceil(allWarranty.length / itemsPerPage);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handlePageChange = (page) => {
    // console.log("page <= totalPages - ", page <= totalPages);
    // console.log("page - " + page);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  //   console.log("totalPages - " + totalPages);
  //   console.log("currentPage - " + currentPage);
  //   console.log("startIndex - " + startIndex);

  const onWarrRowClick = (rowContent) => {
    // console.log("rowContent",rowContent);
    // console.log("createdFromBrand",createdFromBrand);

    navigate("/warrantyReq");
    setSelectedWarranty(rowContent);
  };

  const fetchData = async () => {
    setIsLoading(true);
    const startDate = filterDate?.startDate;
    const endDate = filterDate?.endDate;

    const ax_fetchWarranty = await ax_warranty_getAllWarranty(
      currentPage,
      searchQuery,
      itemsPerPage,
      createdFromBrand,
      startDate,
      endDate
    );

    if (!ax_fetchWarranty || !ax_fetchWarranty.success) {
      return; // Handle this case (show a message or fallback UI)
    }

    if (ax_fetchWarranty.code === 200 && ax_fetchWarranty.success) {
      // console.log("ax_fetchWarranty - " + JSON.stringify(ax_fetchWarranty));
      //   console.log("count" + JSON.stringify(ax_fetchWarranty.data.length));
      setAllWarranty(ax_fetchWarranty.data);
      setTotalPages(ax_fetchWarranty.totalPages);
      setIsLoading(false);
    }
    // console.log("fetchData");
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchData();
    }, 500); // debounce delay

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [currentPage, searchQuery, createdFromBrand, filterDate]);

  //   if (allWarranty.length === 0) {
  //     return <div className="text-center p-4">No warranties found.</div>;
  //   }

  //   console.log("allWarranty - ", JSON.stringify(allWarranty));
  //   //   console.log("displayedWarranty - ", JSON.stringify(displayedWarranty));
  //   console.log("currentPage - ", JSON.stringify(currentPage));
  //   console.log("searchQuery - ", JSON.stringify(searchQuery));
  // console.log("createdFromBrand",createdFromBrand);

  return (
    <section className="pb-4 xl:pl-4 bg-[#F3EEEE]">
      <div className="p-4 bg-white">
        <TableHeadOptions
          title={"Warranty Card List"}
          searchQuery={searchQuery}
          handleSearchChange={handleSearchChange}
          toggleFilter={toggleFilter}
          isSortedLatest={isSortedLatest}
          filterDate={filterDate}
          setFilterDate={setFilterDate}
        />
        {isLoading ? (
          <main className="h-[calc(100vh-66.5vh)] w-full flex items-center justify-center">
            <Loading />
          </main>
        ) : (
          <Table
            data={allWarranty}
            headerFields={[
              {
                label: "S.No",
                backendField: "serialNumber",
              },
              {
                label: "Name",
                backendField: "name",
              },
              {
                label: "Email",
                backendField: "email",
              },
              {
                label: "Phone",
                backendField: "phone",
              },
              {
                label: "Wow No",
                backendField: "wowNo",
              },
              {
                label: "Frame No",
                backendField: "frameNo",
              },
              {
                label: "Status",
                backendField: "warrStatus",
              },
              {
                label: "Purchase Date",
                backendField: "purchaseDate",
              },
            ]}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            onRowClick={onWarrRowClick}
          />
        )}
        {/* {allWarranty.length === 0 ? (
          <div className="w-full h-[355px] flex items-center justify-center">
            <div>
              <ArrRefresh2O className="w-5 h-5 animate-spin" />
            </div>
            <div className="ml-2"> Fetching warranties!</div>
          </div>
        ) : (
          <main className="h-full overflow-scroll">
            <table className="w-full h-full border border-gray-200 bg-white rounded-lg shadow-md overflow-hidden mt-4">
              <thead className="bg-gray-100">
                <tr>
                  {[
                    "S.No",
                    "Name",
                    "Email",
                    "Phone",
                    "Wow No",
                    "Frame No",
                    "Status",
                    "Date",
                  ].map((heading, index) => (
                    <th
                      key={index}
                      className="p-3 text-left text-gray-700 font-medium text-sm border-b"
                    >
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="w-full">
                {allWarranty?.map((row, index) => {
                  const serialNumber =
                    (currentPage - 1) * itemsPerPage + index + 1;
                  const {
                    _id,
                    name,
                    email,
                    phone,
                    // useCase,
                    // ageGroup,
                    wowNo,
                    frameNo,
                    warrStatus,
                    purchaseDate,
                    // pincode,
                    // state,
                    // city,
                    // brand,
                    // sourceOfPurchase,
                  } = row;
                  return (
                    <tr
                      key={_id}
                      className="hover:bg-gray-50 transition"
                      onClick={() => onWarrRowClick(row)}
                    >
                      <td className="p-3 border-b text-sm text-gray-600">
                        {serialNumber}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {name}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {email}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {phone}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {wowNo}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {frameNo}
                      </td>
                      <td
                        className={`p-3 border-b text-sm font-semibold ${
                          statusColors[warrStatus?.toLowerCase()]
                        }`}
                      >
                        {warrStatus}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {purchaseDate
                          ? new Date(purchaseDate).toISOString().split("T")[0]
                          : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination
              handlePageChange={handlePageChange}
              currentPage={currentPage}
              totalPages={totalPages}
            />
          </main>
        )} */}
      </div>
    </section>
  );
};

export default WarrList;
